import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image"


const StyledHeroContainer = styled(Container)`

`
const Accurate = () => {
    return (
        <StyledHeroContainer>
            <div className="row">
                <div className="col-sm-6">
                    <p><span className="fw-bolder fs-5 text-justify">LinkedIn Enrichment</span></p> 
                    <p>Dropcontact only supports LinkedIn scraping functionality via third party tools which adds up to the cost and stretches the scraping process. Whereas, Clearout offers Chrome extension for LinkedIn Prospecting making the process a lot easier.</p>
                </div>
                <div className="col-sm-6 mw-100">
                    <StaticImage src="../../../images/Linkedin_scraping_co_vs_dropcontact.jpg" alt="Validate email address with Clearout's Email Verifier for accurate results and guaranteed email deliverability" placeholder="blurred" />
                </div>
            </div>

        </StyledHeroContainer>
    )
}

export default Accurate;